import { render, staticRenderFns } from "./PanelChat.vue?vue&type=template&id=c0faf6a8"
import script from "./PanelChat.vue?vue&type=script&lang=js"
export * from "./PanelChat.vue?vue&type=script&lang=js"
import style0 from "./PanelChat.vue?vue&type=style&index=0&id=c0faf6a8&prod&lang=scss&scopped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports